import { postApiGalaxyServer } from 'services/api';

export type FilterIntegrationsByTenantPayload = {
  integrations: string[];
};

export type FilterIntegrationsByTenantResult = {
  name: string;
  onRealm: boolean;
};

/**
 * POST /realm/filterIntegrationsByTenant
 * Body: { integrations: string[] } of IADS service names
 * Response: Array<{ name: string; onRealm: boolean }> — every requested name
 * that resolves to a non-archived integration-agent service AND is either
 * already on the realm or available to the tenant. `onRealm` reflects whether
 * the service is already present on `realm.realmServices`.
 *
 * Tenant/realm headers are handled by the caller (useAppQuery's buildConfig).
 */
export const filterIntegrationsByTenantApi = ({
  params,
  token,
  config = {},
}: BaseApiParams<FilterIntegrationsByTenantPayload>) => {
  return postApiGalaxyServer<FilterIntegrationsByTenantPayload, FilterIntegrationsByTenantResult[]>(
    `/realm/filterIntegrationsByTenant`,
    params,
    config,
    token,
  );
};
